module.exports.parse = require('./lib/parse');
module.exports.METERS_PER_FOOT = module.exports.parse.METERS_PER_FOOT;
module.exports.format = require('./lib/format');
// console.log(module.exports);



//////////////////
// WEBPACK FOOTER
// ./node_modules/footinch/index.js
// module id = 189
// module chunks = 0